module.exports = __webpack_public_path__ + "media/images/emblems/Grandson-coat_of_arms-5762739e4cba51cf237368154f0ae5cf.svg";